export const ANALYTICS_CONSENT_KEY = 'sgp-analytics-consent';

const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';
let analyticsStarted = false;

export const hasAnalyticsConsent = () =>
  window.localStorage.getItem(ANALYTICS_CONSENT_KEY) === 'granted';

export const initAnalytics = () => {
  if (!hasAnalyticsConsent()) return;
  if (analyticsStarted || window.posthog?.__loaded) {
    window.posthog?.opt_in_capturing?.();
    return;
  }
  analyticsStarted = true;

  const posthog = (window.posthog = window.posthog || []);
  if (!posthog.init) {
    posthog._i = [];
    const methods = [
      'capture', 'opt_out_capturing', 'opt_in_capturing', 'startSessionRecording',
      'stopSessionRecording', 'get_distinct_id', 'reset',
    ];
    methods.forEach((method) => {
      posthog[method] = (...args) => posthog.push([method, ...args]);
    });
    posthog.init = (key, config) => {
      posthog._i.push([key, config]);
      const script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://us-assets.i.posthog.com/static/array.js';
      document.head.appendChild(script);
    };
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    persistence: 'localStorage+cookie',
    capture_pageview: false,
    capture_pageleave: true,
    session_recording: {
      recordCrossOriginIframes: false,
      capturePerformance: false,
      maskAllInputs: true,
      maskTextSelector: '#contact',
    },
  });
};

export const track = (event, properties = {}) => {
  if (!hasAnalyticsConsent()) return;
  initAnalytics();
  window.posthog?.capture?.(event, properties);
};

export const disableAnalytics = () => {
  window.posthog?.stopSessionRecording?.();
  window.posthog?.opt_out_capturing?.();
};
